import { delUser, queryUserList } from '@api/roleManagement';
import { DeletePrompt } from '@components/Popup/Prompt/deletePrompt';
import ZeissTable from '@components/table';
import { AdminPopup } from '@views/pages/RoleManagement/Popup/admin';
import type { TableProps } from 'antd';
import { PaginationProps, Space, message } from 'antd';
import { useEffect, useState } from 'react';
import { useImmer } from 'use-immer';
import { ROLEIDLIST } from '../type';
import { use_ROLESECTOR_COLUMNS } from './columns';
import './index.scss';
interface RecordData {
  username?: string;
  email?: string;
  phone?: string;
  userId?: string;
}

interface PageProps {
  pageNumber: number;
  pageSize: number;
}

// interface Props {
//   roleIdList: {
//     Admin?: number;
//     Sales?: number;
//     Sector?: number;
//   };
// }

export const useRoleSector = ({
  roleIdList,
  refreshTable,
  dicList
}: ROLEIDLIST) => {
  const [data, setData] = useImmer([]);
  const [open, setOpen] = useState(false); //修改弹框
  const [deletePopStaus, setDeletePopStaus] = useState(false); //删除弹框
  const [recordData, setRecordData] = useImmer<RecordData>({}); //选中的表格行数据
  const [delUserId, setDelUserId] = useState(''); //删除的userId
  const [total, setTotal] = useState<number>(0);
  const [pageInfo, setPageInfo] = useImmer<PageProps>({
    pageNumber: 1,
    pageSize: 10
  });
  const ROLESECTOR_COLUMNS = use_ROLESECTOR_COLUMNS();
  //分页
  const pageProps: PaginationProps = {
    current: pageInfo.pageNumber,
    pageSize: pageInfo.pageSize,
    total: total
  };

  //显示删除框
  const handleClickDel = (id: string) => {
    setDeletePopStaus(true);
    setDelUserId(id);
  };

  //显示修改框
  const handleClickEdit = (record: RecordData) => {
    setOpen(true);
    setRecordData(record);
  };

  const columns: TableProps<RecordData>['columns'] = [
    ...ROLESECTOR_COLUMNS,
    {
      title: '操作',
      key: 'action',
      width: '15%',
      align: 'center',
      render: (record: RecordData) => (
        <Space size="large">
          <a onClick={() => handleClickEdit(record)}>修改</a>
          <div
            className="pc-roleAdmin-del"
            onClick={() => handleClickDel(record.userId || '')}
          >
            删除
          </div>
        </Space>
      )
    }
  ];

  const getDataSource = async (current = null, pageSize = null) => {
    const res = await queryUserList({
      ...pageInfo,
      pageNumber: current || 1,
      pageSize: pageSize || 10,
      roleId: roleIdList?.Sector?.roleId
    });
    setPageInfo({
      pageNumber: current || 1,
      pageSize: pageSize || 10
    });
    setTotal(res?.users?.total);
    setData(res?.users?.records || []);
  };

  const deleteAccount = async () => {
    await delUser({
      userIds: [delUserId]
    });
    setOpen(false);
    message.success('删除成功!');
    getDataSource();
  };

  const handleChange = ({ current, pageSize }: any) => {
    getDataSource(current, pageSize);
  };

  useEffect(() => {
    if (roleIdList.Sector !== undefined) getDataSource();
  }, [roleIdList.Sector]);

  useEffect(() => {
    if (refreshTable && roleIdList.Sector) getDataSource(); //新增后刷新页面
  }, [refreshTable]);

  const roleSectorComponent = (
    <>
      <ZeissTable
        columns={columns}
        dataSource={data}
        bordered={false}
        onChange={handleChange}
        pagination={pageProps}
      />
      <DeletePrompt
        popupTitle="确认删除该账号？"
        open={deletePopStaus}
        setOpen={setDeletePopStaus}
        confirmCallback={deleteAccount}
      />
      {open && (
        <AdminPopup
          record={recordData}
          dicList={dicList}
          open={open}
          getDataSource={getDataSource}
          setOpen={setOpen}
          currentTabKey={'Sector'}
        />
      )}
    </>
  );

  return {
    roleSectorComponent
  };
};
